import classNames from 'classnames'
import React, { Component } from 'react';
import ContentEditable from 'react-contenteditable'
import ReactDOM from 'react-dom';
import Tag from '../components/Tag'
import { TOGGLE_COMMENTS_SUCCESS } from '../actionTypes'
import setFocusToEnd from '../functions/setEndOfContenteditable'
import storage from '../actions/storage'
import { guid, getArrForLightBox } from '../selectors'
import Gallery from '../components/Gallery';
import LineEditable from '../components/LineEditable'
import DatesLine from '../components/DatesLine'
import DatePickerCustom from '../components/DatePickerCustom'
import handleImageUpload from '../functions/handleImageUpload'
import 'nprogress/nprogress.css'
import NProgress from 'nprogress'
import Icon from '@material-ui/core/Icon';
import * as R from 'ramda'




//import handleJimp from '../functions/handleJimp'
import favicons from '../data/favicons'
import { conditionCommentsTime, conditionLineUpdateTime, getCaretPos, setCaretPos, saveCaretPosition } from '../functions/snippets'
import linkifyHtml from 'linkifyjs/html';
import Selection from '../functions/Selection'
import rangy from 'rangy'
import 'rangy/lib/rangy-selectionsaverestore';

NProgress.configure({ showSpinner: true, easing: 'ease', speed: 500, minimum: 0.6 })



//rangy.init();


class Line extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLineNavOn: false,
            isFocusOn: false,
            isHoverOn: false,
            tagValue:'',
            startDate: new Date(),
            isOpenDate: false,
            newDateLabel: 'Deadline',

            dates: [
                {
                    label: 'верстка',
                    date: new Date(),
                },
                {
                    label: 'Дизайн',
                    date: '',
                },
                {
                    label: 'Deadline',
                    date: new Date(),
                }
            ]
        }
    }


    componentDidMount () {
        document.body.addEventListener('click', this.closeLineNav);

        setTimeout(() => {
            //document.querySelector('.react-datepicker__portal').addEventListener('click', this.setState({isOpenDate: false}));
        })
    }
    componentWillUnmount () {
        document.body.removeEventListener('click', this.closeLineNav);
    }


    toggleLineNav = e => {
        this.setState({ isLineNavOn: !this.state.isLineNavOn })
    }

    closeLineNav = e => {
        const moreNav = document.querySelector('.more-nav__icon-wrap.active');
        if (!e.path.includes(moreNav)){
            this.setState({ isLineNavOn: false })
        }
    }


    onFocus = () => {
        this.setState({ isFocusOn: true })
        //this.focusLineInput();
    };
    onBlur = () => {
        this.setState({ isFocusOn: false })
    };

    //onMouseEnter = () => this.setState({ isHoverOn: true });
    onMouseLeave = () => {
        //this.setState({ isHoverOn: false });
        //this.setState({ isFocusOn: false });
    }
    focusLineInput () {
        const input = ReactDOM.findDOMNode(this.input);
        setFocusToEnd(input)
    }

    /*shouldComponentUpdate(nextProps, nextState) {

        return true
    }*/

    handleTagSubmit = (event) => {
        event.preventDefault()

        const id = this.props.keyList
        const { addTag } = this.props
        const { tagValue } = this.state
        addTag(id, tagValue)
        this.setState({
            tagValue: ''
        })
    }

    handleTagChange = (event) => {
        this.setState({
            tagValue: event.target.value
        })
    }


    getTags = () => {
        const { allTags } = this.props;

        if(!this.state.tagValue.length) return  allTags

        return allTags && allTags.filter(tag => !tag.text.trim().toLowerCase().indexOf(this.state.tagValue.trim().toLowerCase()))
    }

    isHaveComment = () => {
        const { id, commentsTime} = this.props;

        return commentsTime[id]
    }

    handleDateChange = (i, date) => {
        const { id, keyList } = this.props;
        let dates = this.props.dates ? this.props.dates : [];
        dates[i].date = Date.parse(date)
        let tempDate = dates[i]
        tempDate.status = 'old'

        this.props.setDateOnLine(keyList, id, dates, tempDate)

    }

    openNewDateWrapHandle = () => {
        this.setState({
            isOpenDate: true
        },
            () => {
                document.querySelector('.react-datepicker__portal').addEventListener('click',  (e) => {
                    if(e.target.className === 'react-datepicker__portal'){
                        this.setState({isOpenDate: false})
                    }
                });
            })
    }

    handleChangeNewDate = (date, label) => {
        const { id, keyList } = this.props;
        let dates = this.props.dates ? this.props.dates : [];
        let dateUnix = Date.parse(date)
        let haveDate = dates.findIndex(item => item.label === label);
        let tempDate

        if(haveDate + 1){
            dates[haveDate].date = dateUnix
            tempDate = dates[haveDate]
            tempDate.status = 'old'
        }else{
            dates.push({ date: dateUnix, label })
            tempDate = { date: dateUnix, label }
            tempDate.status = 'new'
        }


        this.props.setDateOnLine(keyList, id, dates, tempDate)

        this.setState({
            isOpenDate: false
        })
    }

    handleRemoveDate = (i) => {
        const { id, keyList } = this.props;
        let dates = this.props.dates ? this.props.dates : [];
        let tempDate = dates[i]
        tempDate.status = 'removed'
        let returnDates = R.remove(i, 1, dates);
        this.props.setDateOnLine(keyList, id, returnDates, tempDate)
    }


    render(){

        const {
            id,
            index,
            indexLine,
            text,
            img,
            checked,
            onChecked,
            onDropBox,
            onInput,
            onDeleteLine,
            allTags,
            addTagToLine,
            addTagToFilter,
            tags=[],
            openComments,
            toggleDropBox,
            fetchComments,
            keyList,
            removeCommentsNotificIds,
            saveFiles,
            user,
            commentsTime,
            editFavicon,
            alertCount,
            alertCountInc,
            filterTags,
            date,
            userUpdate,
            editUserLineUpdateTime,
            faviconNotific,
            rangyReducer,
            saveRangy,
            onlyActive,
            dates
        } = this.props;



        let textParse = '';
        const toggleLineNav = this.toggleLineNav
        const toggleLineTags = this.toggleLineTags
        //const onFocus = this.onFocus
        const onBlur = this.onBlur
        const line = {
            id,
            text,
            index,
            date: Date.now(),
            userUpdate: user.id
        }

        const filteredTags = allTags.filter




        const handleAddTagToLine = (index, keyLine) => {
            addTagToLine(index, keyLine, line)
            this.focusLineInput()


        }

        const handleOpenComments = () => {
            openComments(line, keyList);
            toggleDropBox(TOGGLE_COMMENTS_SUCCESS)
            fetchComments(keyList, line.id, user)
            removeCommentsNotificIds(line.id)
        }

        const handleOnInput = (e) => {
            const text = e.target.value
            /*var savedSel = null;
            var savedSelActiveElement = null;

            function saveSelection() {
                // Remove markers for previously saved selection
                if (savedSel) {
                    rangy.removeMarkers(savedSel);
                }
                savedSel = rangy.saveSelection();
                savedSelActiveElement = document.activeElement;
            }

            function restoreSelection() {
                if (savedSel) {
                    rangy.restoreSelection(savedSel, true);
                    savedSel = null;
                    window.setTimeout(function() {
                        if (savedSelActiveElement && typeof savedSelActiveElement.focus != "undefined") {
                            savedSelActiveElement.focus();
                        }
                    }, 1);
                }
            }*/






            /*const input = ReactDOM.findDOMNode(this.input);
            let pos = getCaretPos(input)
            var restore = saveCaretPosition(input);

            //saveSelection()

            //let selection = new Selection(input);
            //selection.saveCurrentSelection()

            const savedSelection = rangy.saveSelection();

            saveRangy(savedSelection)

            console.log(savedSelection)

            const asyncFunc = async () => {

            }*/
                onInput(text)
            /*asyncFunc().then(() => {
                //setCaretPos(input, pos)
                //selection.restoreSelection()
                //restore()
                //restoreSelection()
                console.log(savedSelection)
                //rangyReducer && rangy.restoreSelection(rangyReducer);
            })*/
        }


        const handlePaste = (event) => {
            var _self = this
            var items = (event.clipboardData || event.originalEvent.clipboardData).items;
            for (var index in items) {
                var item = items[index];
                var title = event.clipboardData.getData('TEXT')
                var ac = title.indexOf('jpg') || title.indexOf('png')
                if (item.kind === 'file' && ac) {
                    event.preventDefault()

                    NProgress.start();


                    console.log(event.clipboardData.getData('TEXT'))
                    var blob = item.getAsFile();
                    var reader = new FileReader();
                    reader.onload = function(event){
                        //console.log(event.target.result)
                        handleImageUpload(event.target.result, (message) => {
                            var nameFile = guid();


                            /*const content = new Blob([message], {type: 'text/plain'});
                            const uploadTask = storage.ref('/img/' + nameFile).put(content);

                            uploadTask.on('state_changed', function () {
                                console.log(123123)

                            });*/

                            let uploadTask = storage.ref('/img/').child(nameFile)
                                .putString(message, 'data_url').then(()=>{
                                let file = {type:'image', title: nameFile}
                               // console.log(file)
                                let textLine = ReactDOM.findDOMNode(_self.input).textContent;
                                saveFiles(file, img)
                                NProgress.done();
                            });

                        })

                        //handleJimp(event.target.result)

                    }; // data url!

                    reader.readAsDataURL(blob);

                }
            }
        }

        const commentsHave = () => {
            const cond = conditionCommentsTime(commentsTime, user.commentsTime, id)

            return cond
        }

        const lineUpdateHave = () => {
            const cond = conditionLineUpdateTime(date, user.lineUpdateTime, id, user.id, userUpdate)

            return cond
        }




        const lineClass = classNames({
            'list': true,
            'list_disabled': checked,
            //'d_n': onlyActive && checked
        });
        const navBtnClass = classNames({
            'more-nav__icon-wrap': true,
            'active': this.state.isLineNavOn
        });
        const navDropClass = classNames({
            'more-nav__drop-list': true,
            'active': this.state.isLineNavOn
        });
        const listDropClass = classNames({
            'list__drop-tags-wrap': true,
            'active': (this.state.isFocusOn )
        });


        const options = {
            attributes: {
                'onClick': 'window.open(this.href)'
            },
            ignoreTags: [
                'style',
            ],
            className: 'lineLinks',

        }

        const editUserLineUpdateTimeHandle = () => {

            const  fetchNotData = async () => {
                await editUserLineUpdateTime(keyList, user.id, id);
            }
            fetchNotData().then(() => {
                faviconNotific()
            })

        }





        return (
            <div className={lineClass} >
                {/*
                    lineUpdateHave() && (<div onClick={ () => editUserLineUpdateTimeHandle() } className="comment-icon__notification-icon comment-icon__notification-icon_line-update"></div>)
                */}

                {/*<div className={listDropClass} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>*/}
                {/*{
                    this.state.isFocusOn && (

                    )
                }*/}
                <div className={listDropClass}>
                    <div className="list__drop-tags-head">Tags:</div>
                    <div className="list__drop-tags-search">
                        <form action="" onSubmit={this.handleTagSubmit}>
                            <input
                                placeholder="Enter tag"
                                type="text"
                                className="list__drop-tags-search-field"
                                value={this.state.tagValue}
                                onChange={this.handleTagChange}
                            />
                            <button type="submit" className="list__drop-tags-btn">
                                <i className="icon-plus"></i>
                            </button>
                        </form>
                    </div>
                    <div className="list__drop-tags">
                        {
                            this.getTags() && this.getTags().map((tag, i) => {
                                const tagActive = tags.indexOf( tag.id ) != -1
                                return(
                                    <Tag
                                        active={tagActive}
                                        key={i}
                                        index={i}
                                        indexLine={index}
                                        tag={tag}
                                        handleDeleteTag={false}
                                        addTagToLine={handleAddTagToLine}
                                        type='addToLine'
                                        keyLine={id}
                                    />
                                )
                            })
                        }
                    </div>


                </div>

                <div className="list__index" onClick={ onChecked }>

                    <div  className="list__index-hint">{ 1 + indexLine }</div>
                </div>
                <div className="list__wrap" >
                    <div className="list__content">
                        <div className="list__content-text">
                            {
                                tags && tags.map((tagKey, i) => {
                                    let tag = allTags.find(tag => {
                                        return tag.id === tagKey
                                    });
                                    if(!tag) return
                                    const tagActive = filterTags.indexOf( tag.id ) != -1
                                    return(
                                        <Tag
                                            active={tagActive}
                                            key={i}
                                            index={i}
                                            indexLine={index}
                                            indexPhysicalLine={indexLine}
                                            tag={tag}
                                            handleDeleteTag={false}
                                            addTagToLine={() => {}}
                                            type='filter'
                                            addTagToFilter={addTagToFilter}
                                        />
                                    )
                                })
                            }

                            <LineEditable
                                ref={input => this.input = input}
                                onInput={ onInput }
                                onFocus={ this.onFocus }
                                onBlur={ this.onBlur }
                                className="list__text"
                                //html={linkifyHtml(text,options)}
                                text={text}
                                onPaste={handlePaste}
                            />

                        </div>
                        {img && <Gallery images={getArrForLightBox(img)} />}



                        {dates && <DatesLine removeDate={this.handleRemoveDate} handleDateChange={this.handleDateChange} dates={dates}/>}





                    </div>
                    <div className="list__nav">
                        <div className="comment-icon" onClick={ handleOpenComments }>
                            <div className="comment-icon__wrap">
                                {
                                    this.isHaveComment() ? (<i className="icon-comment icon-comment_is-have"></i>) : (<i className="icon-comment"></i>)
                                 }
                            </div>
                            {/*commentsHave() && (<div className="comment-icon__notification-icon"></div>)*/}
                        </div>

                        <div className='more-nav'>
                            <div className={navBtnClass} onClick={ toggleLineNav }>
                                <i className="icon-more"></i>
                            </div>
                            <div className={navDropClass}>
                                <div className="more-nav__drop-element more-nav__drop-element_blue-coloe" onClick={this.openNewDateWrapHandle}>
                                    <div className="more-nav__drop-icon-wrap">
                                        <Icon>access_time</Icon>
                                    </div>
                                    <div className="more-nav__drop-hint">Add date</div>
                                </div>
                                <div className="more-nav__drop-element" onClick={onDeleteLine}>
                                    <div className="more-nav__drop-icon-wrap">
                                        <i className="icon-delete"></i>
                                    </div>
                                    <div className="more-nav__drop-hint">Delete</div>
                                </div>

                             </div>
                        </div>
                    </div>
                </div>

                {
                    this.state.isOpenDate && (
                        <DatePickerCustom
                            changeNewDate={this.handleChangeNewDate}
                        />
                    )
                }
            </div>
        )
    }
}


export default Line;


// WEBPACK FOOTER //
// ./src/components/Line.js